export function concatDocumentPath(pathItems) {
    return pathItems.join(" › ");
}
